import { render, staticRenderFns } from "./interfaceManage.vue?vue&type=template&id=0338b7c6&scoped=true&"
import script from "./interfaceManage.vue?vue&type=script&lang=ts&"
export * from "./interfaceManage.vue?vue&type=script&lang=ts&"
import style0 from "./interfaceManage.vue?vue&type=style&index=0&id=0338b7c6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0338b7c6",
  null
  
)

export default component.exports